import React from 'react'
import { useNavigate } from 'react-router-dom';

const Listings = (props) => {
  const navigate = useNavigate();

  //Navigate to a single product:
  const handleSingleProductNavigation = (item) => {
    navigate(`/single-product/${item.product_id}`, { state: { item: item } });
  };

  return (
    <>
      <section>
        <div className='container'>
          <div class="container-fluid">
            <div class="row">
              <div class="d-md-block col-md-5 col-lg-4 col-xl-4">
                <div class="mb-4 p-4 cst-border-white">
                  <div class="pt-3">
                    <ul class="navbar-nav">
                      <div className='container mt-5'>
                        <div className='text-white'><h1>Top sellers</h1></div>
                        <div className='text-white cst-font-tahoma'><h2>Category name</h2></div>
                        <div className='text-white cst-font-tahoma'><h2>discover products</h2></div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-md-7 col-lg-8 col-xl-8 ">
                <div class="mb-5 mt-5">
                  <div class="row">
                    {props.productData.flat().map((item, index) => {
                      return <>
                        <div class="col-xl-4 col-md-6 mb-4 " >
                          <div class="card cst-cursor-pointer" key={index} >
                            <img src={`${process.env.REACT_APP_BASE_URL}/${'productImages/' + item.product_image}`}
                              className='card-img-top'
                              onClick={() => handleSingleProductNavigation(item)}
                              style={{ maxHeight: "248px", minHeight: "248px" }}
                            />
                          </div>
                        </div>
                      </>
                    })}
                    {props.productData.flat().length == 0 ? <><h1 className='text-center text-white'>Products are not Available..</h1></> : ""}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Listings